(function(){
  var s=document.createElement('style');
  s.textContent='.gp .thumbs.thumbs-3{grid-template-columns:repeat(3,1fr)}.gp .ship.ship-2{grid-template-columns:repeat(2,1fr)}@media(max-width:900px){.gp .ship.ship-2{grid-template-columns:1fr}}.gp .gpnav{border-bottom:1px solid var(--wire)}.gp .gpnav .w{display:flex;align-items:center;justify-content:space-between;gap:16px;padding-block:18px}.gp .gpbrand{font-family:var(--fd);font-weight:800;font-size:1.35rem;letter-spacing:.16em;color:var(--bone);text-decoration:none}.gp .gpcart{font-family:var(--fm);font-size:.74rem;letter-spacing:.12em;text-transform:uppercase;color:var(--bone);text-decoration:none;border:1px solid var(--wire);padding:9px 14px}.gp .gpcart:hover{border-color:var(--halo);color:var(--halo)}body{margin:0;background:#0B0B0C}';
  document.head.appendChild(s);
})();
(function(){
  var frame=document.getElementById('gp-frame'),cv=document.getElementById('gp-cv');
  var still=document.getElementById('gp-still'),cap=document.getElementById('gp-cap'),scrub=document.getElementById('gp-scrub');
  var vid=document.getElementById('gp-vid'),pr=document.getElementById('gp-price');
  var chips=Array.prototype.slice.call(document.querySelectorAll('.gp .chip'));
  chips.forEach(function(c){
    c.addEventListener('click',function(){
      if(c.disabled)return;
      chips.forEach(function(x){x.classList.remove('on');});
      c.classList.add('on');
      if(vid)vid.value=c.getAttribute('data-id');
      if(pr)pr.textContent=c.getAttribute('data-price');
    });
  });
  if(!frame||!cv)return;
  var srcs=[];
  try{srcs=JSON.parse(document.getElementById('gp-frames').textContent)||[];}catch(e){}
  srcs=srcs.filter(function(u){return u&&u.indexOf('spin-')>-1;});
  if(!srcs.length)return;
  var ctx=cv.getContext('2d'),N=srcs.length,pos=0,W=0,H=0,stillOn=false;
  var auto=!window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var imgs=srcs.map(function(s){var im=new Image();im.onload=draw;im.src=s;return im;});
  function label(){var t=pos/(N-1);return t<0.20?'Гръб · принт':(t>0.80?'Лице · бродерия':'Страничен изглед');}
  function draw(){
    if(!W||!H)return;
    var i=Math.round(pos);if(i<0)i=0;if(i>N-1)i=N-1;
    var im=imgs[i];ctx.clearRect(0,0,W,H);
    if(!im||!im.complete||!im.naturalWidth)return;
    var r=Math.min(W/im.naturalWidth,H/im.naturalHeight);
    var dw=im.naturalWidth*r,dh=im.naturalHeight*r;
    ctx.drawImage(im,(W-dw)/2,(H-dh)/2,dw,dh);
  }
  function ui(){
    var t=pos/(N-1);
    scrub.style.width=(t*100)+'%';
    frame.setAttribute('aria-valuenow',Math.round(t*359));
    if(!stillOn)cap.textContent=label();
  }
  function apply(){draw();ui();}
  function resize(){
    var r=frame.getBoundingClientRect();if(!r.width)return;
    var d=Math.min(window.devicePixelRatio||1,2);W=r.width;H=r.height;
    cv.width=Math.round(W*d);cv.height=Math.round(H*d);ctx.setTransform(d,0,0,d,0,0);draw();
  }
  function stop(){auto=false;frame.classList.add('touched');}
  var drag=false,lx=0;
  frame.addEventListener('pointerdown',function(e){
    if(stillOn)return;
    drag=true;lx=e.clientX;stop();frame.classList.add('drag');
    if(frame.setPointerCapture)frame.setPointerCapture(e.pointerId);
  });
  frame.addEventListener('pointermove',function(e){
    if(!drag)return;
    pos+=(e.clientX-lx)*(N/320);
    if(pos<0)pos=0;if(pos>N-1)pos=N-1;
    lx=e.clientX;apply();
  });
  ['pointerup','pointercancel'].forEach(function(ev){
    frame.addEventListener(ev,function(){drag=false;frame.classList.remove('drag');});
  });
  frame.addEventListener('keydown',function(e){
    if(stillOn)return;
    var s=e.shiftKey?4:1;
    if(e.key==='ArrowRight')pos+=s;
    else if(e.key==='ArrowLeft')pos-=s;
    else if(e.key==='Home')pos=0;
    else if(e.key==='End')pos=N-1;
    else return;
    if(pos<0)pos=0;if(pos>N-1)pos=N-1;
    e.preventDefault();stop();apply();
  });
  Array.prototype.slice.call(document.querySelectorAll('.gp .th')).forEach(function(t){
    t.addEventListener('click',function(){
      Array.prototype.slice.call(document.querySelectorAll('.gp .th')).forEach(function(x){x.classList.remove('on');});
      t.classList.add('on');
      var s=t.getAttribute('data-still');
      if(s){still.src=s;still.hidden=false;stillOn=true;auto=false;frame.classList.add('sticky');cap.textContent=t.getAttribute('data-cap');}
      else{still.hidden=true;stillOn=false;frame.classList.remove('sticky');apply();}
    });
  });
  var t0=0,SW=3600;
  function loop(ts){
    if(auto&&!stillOn){if(!t0)t0=ts;var p=((ts-t0)%(SW*2))/SW;pos=(p<=1?p:2-p)*(N-1);apply();}
    else t0=0;
    requestAnimationFrame(loop);
  }
  if(window.ResizeObserver)new ResizeObserver(resize).observe(frame);
  window.addEventListener('resize',resize);
  resize();apply();requestAnimationFrame(loop);
})();
